<template>
  <div class="payment allow-select">
    <ion-row justify-content-center>
        <div class="payment-container">
            <div style="width: 100%;" v-if="$route.params.type == 'bankdeposit'">
              <p style="text-align: justify;">Thank you for reserving your subscription for Lawyerly Premium. Please complete payment within 7 days and send details of your payment through (<b>Profile &#10142; Update Payment </b>) or by clicking on the button (<b>Update Payment</b>) below. Your reservation will be waived automatically if you are unable to complete payment by <b>{{getExpiry}}</b>.</p>
              <p style="font-family: Roboto; font-size: 1.1em; margin-top: 1em;">You can transfer payment to the following bank accounts:</p>            
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">BANK NAME:	<b>East West Bank</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NAME: <b>Bitesize Digital Group, Inc.</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NO.: <b>200037027609</b></p>

              <p style="font-family: Roboto; font-size: 1.1em; margin: 15px 0 5px 0;">BANK NAME: <b>Chinabank</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NAME: <b>Bitesize Digital Group, Inc.</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NO.: <b>1280-00-00827-8</b></p>
              <img style="display: block; margin: 1.5em auto;" :src="gcash"/>
              <h4 style="margin-top: 60px;">How to update payment</h4>
              <img style="display: block; margin: 1.5em auto; max-width: 80%; border: 1px solid rgba(0,0,0,0.2);" :src="step1"/>
              <hr/>
              <img style="display: block; margin: 1.5em auto; max-width: 80%; border: 1px solid rgba(0,0,0,0.2);" :src="step2"/>
            </div>
            <div style="width: 100%;" v-if="$route.params.type == 'bankdetails'">
              <p style="text-align: justify;">Please complete payment within 7 days and send details of your payment through (<b>Profile &#10142; Update Payment </b>) or by clicking on the button (<b>Update Payment</b>) below. Your reservation will be waived automatically if you are unable to complete payment after 7 days.</p>
              <p style="font-family: Roboto; font-size: 1.1em;">You can transfer payment to the following bank accounts:</p>            
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">BANK NAME:	<b>East West Bank</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NAME: <b>Bitesize Digital Group, Inc.</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NO.: <b>200037027609</b></p>

              <p style="font-family: Roboto; font-size: 1.1em; margin: 15px 0 5px 0;">BANK NAME: <b>Chinabank</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NAME: <b>Bitesize Digital Group, Inc.</b></p>
              <p style="font-family: Roboto; font-size: 1.1em; margin: 5px 0;">ACCOUNT NO.: <b>1280-00-00827-8</b></p>
              <img style="display: block; margin: 1.5em auto;" :src="gcash"/>
              <h4 style="margin-top: 60px;">How to update payment</h4>
              <img style="display: block; margin: 1.5em auto; max-width: 80%; border: 1px solid rgba(0,0,0,0.2);" :src="step1"/>
              <hr/>
              <img style="display: block; margin: 1.5em auto; max-width: 80%; border: 1px solid rgba(0,0,0,0.2);" :src="step2"/>
            </div>
            <p v-if="$route.params.type == 'success'">Thank you for your subscription. Your payment was successful.</p>
            <p v-if="$route.params.type == 'error'">Your payment is on hold because the payment tab was closed before proceeding the payment. You may pay again through the <b>Profile</b> page.</p>
            <p v-if="$route.params.type == 'failed'">We're sorry to inform you that your payment was <b>unsuccessful</b>. You may try again later!</p>
            <ion-button style="float: right; margin-top: 1em;" @click="$router.push('/')">Done</ion-button>
        </div>
    </ion-row>
  </div>
</template>
<script>

import config from "../../config.js";
import { format } from "date-fns";
import gcash from "@/assets/gcash.png";
import step1 from "@/assets/step1.png";
import step2 from "@/assets/step2.png";

export default {
  data() {
    return {
      popupContent: false,
      plans: this.$config.plans,
      gcash: gcash,
      step1: step1,
      step2: step2
    }
  },

  methods: {
    async bankDeposit() {
      const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
      const doc = {
        type: this.$route.params.type,
        type_: this.plans[idx],
        payment: {
          type: 'bank_deposit',
          label: 'Bank Deposit',
          proof: {
            img: "",
            reference: "",
            date: ""
          }
        }
      };
      const res = await this.$http({
        method: "POST",
        url: config.api.url + "/subscribe",
        data: doc,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      //console.log(res);
    }
  },
  computed: {
    getExpiry() {
      const d = new Date;
      return format(d.setDate(d.getDate() + 7), "MMM. dd, yyyy")
    }
  },

  mounted() {
    this.$store.commit("ui/setHeaderTitle", "Payment Result");
    // if(this.$route.params.type) {
    //   if(this.$route.params.type) {
    //     const idx = this.plans.findIndex(p => p.type == this.$route.params.type);
    //     if(idx < 0) {
    //       this.$router.push('/subscribe');
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>
  ion-button {
    color: #fff !important;
  }
  ion-icon[name="checkmark-circle"] {
    color: #18bc9c;
  }

  ion-icon[name="close-circle"] {
    color: #ff5858;
  }

  .payment table {
      min-width: 400px;
  }

  .payment table tbody tr td {
    vertical-align: top;
    padding-top: 10px;
  }

  .sub-popup {
    padding: 1.25em 1em;
    width: 100%;
  }

  .sub-buttons {
    display: flex;
    width: 100%;
  }

  .sub-buttons button:before{
    content:'';
    float:left;
    padding-top:100%;
  }

  .sub-buttons button div{
   height: 100%;
  }

  .sub-buttons ion-button {
    margin: 0.5em 0;
  }

  .sub-buttons button div h3, .sub-buttons button div h4 {
    color: #ffffff;
    margin: 0 0 5px 0;
  }

  .sub-buttons button div h4 {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .price-col {
    padding: 0 5px 0 1.5em;
    text-align: right;
  }

  @media (min-width: 770px) {
    .payment-container {
      width: 720px;
    }
  }
</style>
